import {
  POST_JOB_SUCCESS,
  POST_JOB_ERROR,
  POST_JOB_CLEAR,
  FILTER_CATEG0RIES,
  SEND_EMAIL,
  EMPTY_EMAIL_DATA,
  NEWS_LETTER,
} from "../actions/types";
const initialState = {
  success: false,
  loading: false,
  filterCategories: [],
  error: undefined,
  email_res:undefined,
  news_letter:undefined
};

//   console.log('newCart==========',newCart)

export default function(state = initialState, action) {
  switch (action.type) {
    case POST_JOB_SUCCESS:
      console.log(action.type);
      return {
        success: true,
        loading: false
      };
    case POST_JOB_CLEAR:
      console.log(action.type);
      return {
        success: false,
        // loading: false,
        error: undefined
      };
    case POST_JOB_ERROR:
      return {
        loading: false,
        error: action.payload
      };
    case FILTER_CATEG0RIES:
      return {
        ...state,
        filterCategories: action.payload
      };

    case SEND_EMAIL:
      return {
        ...state,
        email_res: action.payload
      };
      case EMPTY_EMAIL_DATA:
        return {
          ...state,
          email_res: action.payload
        };
      case NEWS_LETTER:
        return {
          ...state,
          news_letter: action.payload
        };
  
    default:
      return state;
  }
}
